import { Component,AfterViewInit,OnInit,ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { distinctUntilChanged, Observable, shareReplay, take, of, EMPTY } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { CustomfilterPipe } from '../../cms-common/Pipes/customfilter.pipe'; 
import { FormControl } from '@angular/forms';
import { CmsService } from '@spartacus/core';
import { ActivatedRoute } from '@angular/router';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';
import { MatCalendar } from '@angular/material/datepicker';
import { HostListener, NgZone } from '@angular/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  override getDayOfWeekNames(): string[] {
    return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  }
}

declare var window:any;

export interface PeriodicElement1 {
  loc: string;
  ordernum: number;
  prodname: string;
  season:string;
  status:string;
  unit:number;
} 

export interface Products {
  materialID: string,
  itemNumber: string,
  quantity: string,
  baseName: string,
  presentationName: string,
  currencyIso: string,
  formattedValue: string,
  doses: string,
  seqId: string,
  sellable: true,
  price: 0
}

@Component({
  selector: 'app-my-orders-left-section',
  templateUrl: './my-orders-left-section.component.html',
  styleUrls: ['./my-orders-left-section.component.scss'],
  standalone: false,
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ]
})

export class MyOrdersLeftSectionComponent implements OnInit,AfterViewInit {
  togglefilterView:boolean=false;
  togglesortView:boolean=false;
  filteredData1:any;
  invoicenumber:number | undefined;
  invoiceseason:string | undefined;
  displayedColumns: string[] = ['combined'];
  dataSource:any=[];
  dataSource1= new MatTableDataSource<any>();
  displayedColumns1: string[] = ['fullProductName','totalOrderdQty','totalInvoiceAmount','totalShippedQty','latestStatus']; 
  displayproduct:string[]=['quantity','shipmentStatus'];
  dataSourceWithPageSize = new MatTableDataSource<PeriodicElement1>;

  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  checkout: any;
  loadedFromSummary: any;
  sortedData: any;
  isPreSeason: boolean = false;
  isInSeason: boolean = false;

  showMessage = false;
  messageType: 'success' | 'error' = 'success';
  messageText = '';

  filteropen(){
    this.togglefilterView=!this.togglefilterView;
    this.togglesortView=false;
  }

  sortopen(){
    this.togglefilterView=false;
    this.togglesortView=!this.togglesortView;
  }

  dropdownValue:any;
  getfilterdata:any;
  apiresponse:any;
  rightsectionresponse:any;
  count=0;
  getstatus:any;
  selectedproducts:any[]=[];
  selectedstatus:any[]=[];
  isLoading = false;
  totalshippingquantity:number=0;

  rightisLoading = false;
  editdata=false;
  editdatasource = new MatTableDataSource<any>();
  editcolumns: string[]=['fullProductName','price','totalOrderdQty','errorMessage'];
  initialQuantities: Products[]=[];
  originalQuantities:number[]=[];
  totalQuantity: number = 0;
  isFormValid:boolean = true;
  activemembership:any;
  nomembership:any;
  membershipdata:any;
  selectedOrder: string | null = null;
  poError: boolean = false;
  originalPoNumber: string = '';

  showingLabel: string = "Showing";
  pageSize: number = 6;
  pageSizeControl = new FormControl(6);
  totalLength = 0;
  currentPage: number = 1;
  valformsummary :any;
  pageSizeOptions: number[] = [5, 10, 15];
  firstvalue:string='';

  filterValues = {
    search: '',
    filterbyproduct:[''],
    filterbystatus:[''],
  };

  showRescheduleModal:boolean=false;
  requiresCustomerService: boolean = false;
  isEditDisabledByPrepayment: boolean = false;
  /**
   * NEW:
   * This flag controls whether Edit button should be disabled
   * when expected delivery date is tomorrow and current Eastern time is after cutoff.
   */
  isEditDisabledByShippingCutoff: boolean = false;
  showShippingCutoffMessage: boolean = false;

  /* ================= CONFIG (REUSABLE) ================= */
  deliveryConfig = {
    maxWindowDays: null as number | null,
    cutoffHour: null as number | null,
    disabledWeekdays: [] as number[],
    apiDisabledDates: [] as string[],
    infoText: ''
  };

  /* ================= STATE ================= */
  isCalendarOpen = false;
  confirmedDate!: Date;
  tempSelectedDate: Date | null = null;
  monthLabel = '';

  confirmedDates: Record<number, Date> = {};
  tempSelectedDates: Record<number, Date | null> = {};
  openCalendarIndex: number | null = null;

  today = new Date();
  minSelectableDate!: Date;
  maxSelectableDate!: Date;
  minRescheduleDate!: Date;

  private apiDisabledSet = new Set<string>();

  @ViewChild('calendarPanel') calendarPanel!: ElementRef;
  calendar!: MatCalendar<Date>;

  @ViewChild('calendar')
  set calendarRef(cal: MatCalendar<Date>) {
    if (!cal) return;
    this.calendar = cal;

    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      this.updateMonthLabel();
      this.cd.detectChanges();
    });

    this.calendar.stateChanges.subscribe(() => {
      this.updateMonthLabel();
      this.cd.detectChanges();
    });
  }

  constructor(
    private dialogservice:ApiFailureDialogService,
    private userInfoService: UserInfoService,
    private cd:ChangeDetectorRef,
    private cmsService:CmsService,
    private activatedRoute: ActivatedRoute,
    private ngZone:NgZone
  ) {
    this.userInfoService.filterstatus().subscribe((data)=>{
      this.getstatus=data;
    });
  }

  ngOnInit(): void {
    this.normalizeToday();
    this.prepareDateWindow();
    this.prepareApiDisabledDates();

    this.isLoading = true;

    this.userInfoService.getDropdownValue().pipe(distinctUntilChanged()).subscribe(
      value => {
        this.dropdownValue = value;

        if (this.dropdownValue) {
          this.sortedData = [];
          this.filterValues = {
            search: '',
            filterbyproduct: [''],
            filterbystatus: [''],
          };

          this.userInfoService.filterproduct(this.dropdownValue).subscribe(
            data => {
              this.getfilterdata = data;
            },
            error => {
              console.error('Error fetching filter product:', error);
              this.isLoading = false;
              this.cd.detectChanges(); 
            }
          );

          this.leftsection(this.dropdownValue);
          this.rightsectionresponse = "";
        } else {
          this.isLoading = false;
          this.cd.detectChanges(); 
        }
      },
      error => {
        console.error('Error fetching dropdown value:', error);
        this.isLoading = false;
        this.cd.detectChanges(); 
      }
    );

    this.userInfoService.MembershipDetails().subscribe(res=>{
      this.membershipdata = res;
    });

    this.cmsService.getComponentData('Membership-myOrdersMessageComponent1').subscribe(res=>{
      this.activemembership=res;
    });

    this.cmsService.getComponentData('Membership-myOrdersMessageComponent2').subscribe(res=>{
      this.nomembership=res;
    });
  }

  ngAfterViewInit(){
    this.cd.detectChanges(); 
  }

  inputsearch(event:Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValues.search =filterValue.trim().toLowerCase(); 
  }

  incrementcountproduct(event:any,i:number){
    if (event.target.checked) {
      this.count++;
      this.selectedproducts.push(event.target.value);
      this.filterValues.filterbyproduct=this.selectedproducts;
    } else {
      var index = this.selectedproducts.indexOf(event.target.value);
      this.selectedproducts.splice(index, 1);
      this.filterValues.filterbyproduct=this.selectedproducts;
      this.count--;
    } 
  } 

  incrementcountstatus(event:any,i:number){
    if (event.target.checked) {
      this.count++;
      this.selectedstatus.push(event.target.value);
      this.filterValues.filterbystatus=this.selectedstatus;
    } else {
      var index = this.selectedstatus.indexOf(event.target.value);
      this.selectedstatus.splice(index, 1);
      this.filterValues.filterbystatus=this.selectedstatus;
      this.count--;
    } 
  } 

  onSortClicked(){
    const sortDirection = this.sort.direction;
    const activeColumn = this.sort.active;
    this.sortedData = [...this.apiresponse.filterData];

    if(this.filteredData1?.length){
      this.sortedData  = [...this.filteredData1];
    }

    if (sortDirection && activeColumn) {
      this.sortedData.sort((a:any, b:any) => {
        const isAsc = sortDirection === 'asc';
        return this.compare(a[activeColumn], b[activeColumn], isAsc);
      });
    }

    this.currentPage=1;
    const starti = (this.currentPage - 1) * this.pageSize;
    const endi = starti + this.pageSize;
    const paginatedData = this.sortedData.slice(starti, endi); 
    this.dataSource.data = paginatedData;
  }

  compare(a: string | number, b: string | number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortTest(val:any){  
    if(val == '1to9' || val == '9to1'){
      const sortState: Sort = {active: 'ordernum', direction: val == '1to9'?'asc': 'desc'};    
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);
      this.onSortClicked();
    }
    else if(val == 'AtoZ' || val == 'ZtoA'){
      const sortState: Sort = {active: 'loc', direction: val == 'AtoZ'?'asc': 'desc'};    
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);
      this.onSortClicked();
    }
    else if(val == 'LeastRecent' || val == 'MostRecent'){
      const sortState: Sort = {active: 'ordernum', direction: val == 'LeastRecent'?'asc': 'desc'};    
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);
      this.onSortClicked();
    }
  }



  leftsection(currentdropdownValue:any){
    this.isLoading = true;

    this.userInfoService.Myorderleftsection(currentdropdownValue).subscribe(
      value => {
        this.apiresponse = value;

        if(this.apiresponse?.errorCode=="500" && localStorage.getItem('FailureDailog') != 'true'){
          this.dialogservice.openErrorDialog();
          localStorage.setItem('FailureDailog', 'true');
          this.isLoading=false;
          this.cd.detectChanges();
        }

        this.dataSource = new MatTableDataSource(this.apiresponse.filterData);
        this.dataSourceWithPageSize = new MatTableDataSource(this.apiresponse.filterData);
        this.resetFilter();

        this.isLoading = false;
        this.cd.detectChanges();

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.resetSort();

        this.totalLength = this.apiresponse.filterData.length;
        this.firstvalue = this.apiresponse?.filterData[0]?.ordernum;

        this.activatedRoute.queryParams.subscribe(
          params => {
            if (params) {
              this.loadedFromSummary = params;
              this.filterValues.search = this.loadedFromSummary?.address;
              this.applyFilter();
              this.firstvalue = this.dataSource.filteredData[0]?.ordernum;
              this.valformsummary = this.loadedFromSummary.address;
            }
          },
          error => {
            console.error('Error reading query params:', error);
            this.isLoading = false;
            this.cd.detectChanges();
          }
        );

        if (this.firstvalue) {
          this.openrightsectio(this.firstvalue);
        } else {
          this.rightsectionresponse = "";
        }
      },
      error => {
        console.error('Error fetching Myorderleftsection data:', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
  }



  applyFilter() {
    this.filteredData1 = new CustomfilterPipe().transform(this.apiresponse.filterData, this.filterValues);
    this.dataSource = new MatTableDataSource(this.filteredData1);
    this.cd.detectChanges();

    this.dataSourceWithPageSize = new MatTableDataSource(this.apiresponse.filterData);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort; 

    this.totalLength = this.filteredData1.length;
    this.currentPage=1;

    const starti = (this.currentPage - 1) * this.pageSize;
    const endi = starti + this.pageSize;
    this.dataSource.data = this.filteredData1.slice(starti, endi); 
  }

  getProgress(deliveredQty:number,totalQty:number){
    return (Math.floor((deliveredQty/totalQty)*100));
  }

  updateTableData() {
    const starti = (this.currentPage - 1) * this.pageSize;
    const endi = starti + this.pageSize;

    if(this.sortedData.length) {
      this.dataSource.data = this.sortedData.slice(starti, endi);
    } else {
      if(this.filteredData1?.length >0){
        this.dataSource.data = this.filteredData1.slice(starti, endi);
      }else{
        this.dataSource.data = this.apiresponse.filterData.slice(starti, endi);
      }
    }
  }

  scrollToTop(): void { 
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onPageSizeChange(event: any) {
    this.pageSize = parseInt(event.target.value, 10);
    this.currentPage = 1;
    this.updateTableData();
  }

  goToLastPage() {
    const totalPages = Math.ceil(this.totalLength / this.pageSize);
    this.currentPage = totalPages;
    this.updateTableData();
  } 

  goToFirstPage() {
    this.currentPage = 1;
    this.updateTableData();
  }

  getPages(): any {
    const totalPages = Math.ceil(this.totalLength / this.pageSize);
    const pages: any = [];
    const startPage = Math.max(1, this.currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) {
      pages.push('...');
    }

    if (endPage < totalPages) {
      pages.push(totalPages);
    }

    return pages;
  }

  goToPage(page: number) {
    this.currentPage = page;
    const starti = (page - 1) * this.pageSize;

    if(this.sortedData.length) {
      this.dataSource.data = this.sortedData.slice(starti, starti + this.pageSize);
    } else {
      if(this.filteredData1?.length >0){
        this.dataSource.data = this.filteredData1.slice(starti, starti + this.pageSize);
      }else{
        this.dataSource.data = this.apiresponse.filterData.slice(starti, starti + this.pageSize);
      }
    }
  } 

  previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  } 

  nextPage() {
    const totlpages = Math.ceil(this.totalLength / this.pageSize);
    if (this.currentPage < totlpages) {
      this.goToPage(this.currentPage + 1);
    }
  } 

  isFirstPage(): boolean {
    return this.currentPage == 1;
  }

  isLastPage(): boolean {
    return this.currentPage == Math.ceil(this.totalLength / this.pageSize);
  }

  isCurrentPage(page: number): boolean {
    return this.currentPage == page;
  }

  backbtn(){
    const mobileback=<HTMLElement>document.getElementById("backbtn");
    const mobiletemp=<HTMLElement>document.getElementById("rightsection");
    const left =<HTMLElement>document.getElementById("leftsection");

    left.classList.remove("lefthide");
    mobiletemp.classList.add("mobileright");
    mobileback.classList.remove("backhide");
  }

  private applyShippingCalendarConfig(): void {
    const cal = this.rightsectionresponse?.shippingCalendar;
    if (!cal) return;

    if (cal.calendarDays != null) {
      this.deliveryConfig.maxWindowDays = Number(cal.calendarDays);
    }

    if (cal.cutoffHour != null) {
      this.deliveryConfig.cutoffHour = Number(cal.cutoffHour);
    }

    if (Array.isArray(cal.disabledWeekdays) && cal.disabledWeekdays.length) {
      this.deliveryConfig.disabledWeekdays = cal.disabledWeekdays.map(Number);
    }

    if (Array.isArray(cal.holidayDates) && cal.holidayDates.length) {
      this.deliveryConfig.apiDisabledDates = cal.holidayDates;
    }

    if (cal.message) {
      this.deliveryConfig.infoText = cal.message;
    }

    this.prepareApiDisabledDates();
    this.prepareDateWindow();
  }

  private applyRescheduleCountConfig(): void {
    const current = Number(this.rightsectionresponse?.currentRescheduleCount ?? 0);
    const max = Number(this.rightsectionresponse?.shippingCalendar?.maxrRescheduleCount);
    this.requiresCustomerService = current >= max;
  }

  openrightsectio(orderid:string){
    const temp= <HTMLElement>document.getElementsByClassName("activeorder")[0];

    if(temp){
      temp.classList.remove("activeorder");
    }

    const temp1= <HTMLElement> <unknown>document.getElementById(orderid);
    if(temp1){
      temp1.classList.add('activeorder');
    }
    this.rightisLoading = true;

    if(orderid){
      orderid=orderid.split("#")[1];
    }

    this.selectedOrder = orderid;
    this.editdata = false;

    /**
     * NEW:
     * reset cutoff disabled state when user selects another order
     */
    this.isEditDisabledByShippingCutoff = false;
    this.isEditDisabledByPrepayment = false;    this.showShippingCutoffMessage = false;

    this.openCalendarIndex = null;
    this.tempSelectedDates = {};
    this.confirmedDates = {};

    this.userInfoService.MyorderRightsection(this.dropdownValue,orderid).subscribe(
      value=>{
        this.rightsectionresponse=value;
        this.rightsectionresponse.totalShippedQty = Number(this.rightsectionresponse.totalShippedQty);
        this.rightsectionresponse.totalOrderedQty = Number(this.rightsectionresponse.totalOrderedQty);

        this.initializeDeliveryDate();
        this.updatePrepaymentEditState();
        this.applyShippingCalendarConfig();
        this.applyOrderDateWindow();

        /**
         * NEW:
         * check whether edit should be disabled after API data is available
         */
        this.updateEditCutoffState();

        this.originalPoNumber = this.rightsectionresponse.poNumber;

        if(this.rightsectionresponse.invoiceLink){
          const invoicelink=this.rightsectionresponse.invoiceLink.split('/');
          this.invoicenumber=invoicelink[3];
          this.invoiceseason=invoicelink[4];
        }

        this.dataSource1 = new MatTableDataSource(this.rightsectionresponse.productDetailsTable);
        this.rightisLoading = false;

        const mobileback=<HTMLElement>document.getElementById("backbtn");
        const mobiletemp=<HTMLElement>document.getElementById("rightsection");
        const left=<HTMLElement>document.getElementById("leftsection");

        left.classList.add("lefthide");
        mobiletemp.classList.remove("mobileright");
        mobileback.classList.add("backhide");

        this.editdatasource = new MatTableDataSource(this.rightsectionresponse.editOrderProducts);
        this.initialQuantities = this.editdatasource.data.map(item => ({ ...item,}));
        this.originalQuantities = this.editdatasource.data.map(item => item.quantity);

        this.applyRescheduleCountConfig();

        this.isPreSeason = this.rightsectionresponse.preSeason === this.dropdownValue;
        this.isInSeason = this.rightsectionresponse.inSeason === this.dropdownValue;

        this.cd.detectChanges();
      },
      error => {
        this.rightisLoading = false;
        this.cd.detectChanges();
      }
    );
  }

  expandedElement: any | null;

  toggleRow(element: any) {
    element.expanded = !element.expanded;
    this.cd.detectChanges();
  }

  /**
   * UPDATED:
   * edit section will not open when blocked by shipping cutoff rule.
   */
  viewEditTable(){
    if (this.isEditDisabled()) {
      this.editdata = false;
      return;
    }

    this.editdata = !this.editdata;
  }

  onKeyPress(event: KeyboardEvent) {
    const char = event.key;
    if (!/^[0-9]$/.test(char)) {
      event.preventDefault();
    }
  }

  calculateTotalQuantiy():number{
    const dataArray = this.editdatasource;

    this.totalQuantity= dataArray.data.reduce((total,element,index)=>{
      if (!this.isPreSeason) {
        if(Number(element.quantity) < this.originalQuantities[index]){
          element.errorMessage = "Sorry, existing order quantities can't be decreased online";
          element.error=true;
          this.isFormValid=false;
        }else{
          element.errorMessage="";
          element.error = false;
        }
      }

      return total + Number(element.quantity);
    },0);

    this.isFormValid = !dataArray.data.some(element=>element.error);
    return this.totalQuantity;
  }

  calculateTotalAmount(element:any) {
    var price=element.formattedValue.replace("$","");
    var finalprice= Number(price);
    return (element.quantity)*(finalprice);
  }

  calculateTotalDoses(){
    return this.totalQuantity*10;
  }

  calculateTotalPrice() {
    const total = this.editdatasource.data.reduce((acc, element) => acc + this.calculateTotalAmount(element), 0);
    return total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  closeEditOrderArea() {
    this.editdatasource.data = this.initialQuantities.map(item => ({ ...item }));
    this.editdata = false;
    this.poError = false; 
    this.rightsectionresponse.poNumber = this.originalPoNumber;

    const apiDate = new Date(this.rightsectionresponse.expectedDeliveryDate + 'T00:00:00');
    this.confirmedDates[0] = apiDate;
    this.tempSelectedDates[0] = apiDate;
    this.openCalendarIndex = null;
  }

  iseditLoading = false;

  private refreshOrderSectionAfterSave(sapOrderID: string): Observable<any> {
    this.isLoading = true;
    this.rightisLoading = true;
  
    return this.userInfoService.Myorderleftsection(this.dropdownValue).pipe(
      tap((leftResponse: any) => {
        this.apiresponse = leftResponse;
  
        if (this.apiresponse?.errorCode === '500' && localStorage.getItem('FailureDailog') !== 'true') {
          this.dialogservice.openErrorDialog();
          localStorage.setItem('FailureDailog', 'true');
          return;
        }
  
        this.dataSource = new MatTableDataSource(this.apiresponse.filterData);
        this.dataSourceWithPageSize = new MatTableDataSource(this.apiresponse.filterData);
  
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
  
        this.totalLength = this.apiresponse.filterData.length;
  
        /*
          Keep existing search/filter state after save.
          This is important because we are refreshing only section data,
          not resetting the full page.
        */
        this.filteredData1 = new CustomfilterPipe().transform(
          this.apiresponse.filterData,
          this.filterValues
        );
  
        this.currentPage = 1;
  
        const starti = (this.currentPage - 1) * this.pageSize;
        const endi = starti + this.pageSize;
  
        if (this.filteredData1?.length > 0 || this.filterValues.search || this.count > 0) {
          this.totalLength = this.filteredData1.length;
          this.dataSource.data = this.filteredData1.slice(starti, endi);
        } else {
          this.totalLength = this.apiresponse.filterData.length;
          this.dataSource.data = this.apiresponse.filterData.slice(starti, endi);
        }
  
        /*
          Re-apply active class for the same order after left list refresh.
          Your row id is row.ordernum, but sapOrderID is the pure order id,
          so we find the matching row from filterData.
        */
        setTimeout(() => {
          const activeOrder = document.getElementsByClassName('activeorder')[0] as HTMLElement;
  
          if (activeOrder) {
            activeOrder.classList.remove('activeorder');
          }
  
          const matchedOrder = this.apiresponse?.filterData?.find((item: any) =>
            String(item.ordernum).includes(String(sapOrderID))
          );
  
          const rowElementId = matchedOrder?.ordernum || sapOrderID;
          const selectedRow = document.getElementById(rowElementId);
  
          if (selectedRow) {
            selectedRow.classList.add('activeorder');
          }
        });
      }),
  
      switchMap(() => {
        return this.userInfoService.MyorderRightsection(this.dropdownValue, sapOrderID);
      }),
  
      tap((rightResponse: any) => {
        this.bindRightSectionAfterRefresh(rightResponse);
      }),
  
      catchError((error) => {
        console.error('Error refreshing order section after save:', error);
        return EMPTY;
      }),
  
      finalize(() => {
        this.isLoading = false;
        this.rightisLoading = false;
        this.iseditLoading = false;
        this.cd.detectChanges();
      })
    );
  }

  private bindRightSectionAfterRefresh(value: any): void {
    this.rightsectionresponse = value;
  
    this.rightsectionresponse.totalShippedQty = Number(this.rightsectionresponse.totalShippedQty);
    this.rightsectionresponse.totalOrderedQty = Number(this.rightsectionresponse.totalOrderedQty);
  
    this.initializeDeliveryDate();
    this.updatePrepaymentEditState();
    this.applyShippingCalendarConfig();
    this.applyOrderDateWindow();
  
    /*
      Recalculate edit disabled status after fresh API data.
    */
    this.updateEditCutoffState();
  
    this.originalPoNumber = this.rightsectionresponse.poNumber;
  
    if (this.rightsectionresponse.invoiceLink) {
      const invoicelink = this.rightsectionresponse.invoiceLink.split('/');
      this.invoicenumber = invoicelink[3];
      this.invoiceseason = invoicelink[4];
    }
  
    this.dataSource1 = new MatTableDataSource(this.rightsectionresponse.productDetailsTable);
  
    this.editdatasource = new MatTableDataSource(this.rightsectionresponse.editOrderProducts);
    this.initialQuantities = this.editdatasource.data.map(item => ({ ...item }));
    this.originalQuantities = this.editdatasource.data.map(item => item.quantity);
  
    this.applyRescheduleCountConfig();
  
    this.isPreSeason = this.rightsectionresponse.preSeason === this.dropdownValue;
    this.isInSeason = this.rightsectionresponse.inSeason === this.dropdownValue;
  
    this.editdata = false;
    this.openCalendarIndex = null;
  
    this.cd.detectChanges();
  }

  saveOrder() {
    
    if (!this.rightsectionresponse.poNumber || this.rightsectionresponse.poNumber.trim() === '') {
      this.poError = true;
      return;
    }
  
    this.poError = false;
  
    const isCancelled = this.editdatasource.data.every(
      (res) => !res.quantity || Number(res.quantity) === 0
    );
  
    if (isCancelled && this.isPreSeason) {
      const modalElement = document.getElementById('cancelorder_popup') as HTMLElement;
  
      if (modalElement) {
        const cancelOrderModal = new window.bootstrap.Modal(modalElement);
        cancelOrderModal.show();
      }
  
      return;
    }
    this.showMessage = false;
    this.messageText = '';
    this.iseditLoading = true;
  
    const updatedOrder = this.editdatasource.data.map((item) => ({
      materialID: item.materialID,
      itemNo: item.itemNumber,
      quantity: item.quantity,
    }));
  
    const newobj = {
      shipToID: this.rightsectionresponse.shipToID,
      sapOrderID: this.rightsectionresponse.orderID,
      maxItemNo: this.rightsectionresponse.maxItemNumber,
      updateOrderProduct: updatedOrder,
      poRefnumber: this.rightsectionresponse.poNumber,
    };
  
    const poRefnumber = this.rightsectionresponse.poNumber;
    const sapOrderID = this.rightsectionresponse.orderID;
    const totalOrderedQty = this.rightsectionresponse.totalOrderedQty;
  
    const showDeliveryDetails =
      this.isInSeason &&
      this.rightsectionresponse.status === 'Ordered' &&
      this.shouldShowDeliveryDetails();
  
    const rescheduleCount: number = this.getUpdatedRescheduleCount();
  
    const expectedDate: string = showDeliveryDetails
      ? this.formatLocalDate(this.confirmedDates[0])
      : '';

    const isONSNOrder = showDeliveryDetails ? this.getIsONSNOrder() : null;

    this.userInfoService.updateOrder(newobj).pipe(
      switchMap((res: any) => {
        if (res === 'cart-success') {
          return this.userInfoService.editconfirmorder(
            poRefnumber,
            sapOrderID,
            this.dropdownValue,
            rescheduleCount,
            expectedDate,
            totalOrderedQty,
            isONSNOrder
          ).pipe(
            tap((data: any) => {
              this.checkout = data;
            }),
            catchError((error) => {
              console.error('Error confirming order:', error);
  
              /*
                Keeping same behavior as your old code:
                even if confirm API fails, do not reload full page.
                Stop loader cleanly and keep UI stable.
              */
              return of(null);
            })
          );
        }
  
        return of(null);
      }),
  
    switchMap(() => {
      return this.refreshOrderSectionAfterSave(sapOrderID);
    }),

    tap(() => {
        this.editdata = false;
        this.poError = false;

        if (this.checkout?.orderStatus === 'Success') {
          this.messageType = 'success';
          this.messageText = 'Order updated successfully';
        } else {
          this.messageType = 'error';
          this.messageText = 'Unable to update your order. Please contact Customer Service.';
        }

        this.showMessage = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.cd.detectChanges();
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
    }),
  
      catchError((err) => {
        console.error('Error updating order:', err);
      
        this.messageType = 'error';
        this.messageText =
          err?.error?.message ||
          'Unable to update your order. Please contact Customer Service.';
        this.showMessage = true;
      
        setTimeout(() => {
          this.showMessage = false;
         // this.cd.detectChanges();
        }, 5000);
      
        return EMPTY;
      }),
  
      finalize(() => {
        this.iseditLoading = false;
        this.isLoading = false;
        this.rightisLoading = false;
        this.cd.detectChanges();
      })
    ).subscribe();
  }

  cancelOrder() {
    this.iseditLoading = true;
  
    const sapOrderID = this.rightsectionresponse.orderID;
  
    this.userInfoService.cancelOrder(sapOrderID, this.dropdownValue).pipe(
      switchMap(() => {
        return this.refreshOrderSectionAfterSave(sapOrderID);
      }),
  
      tap(() => {
        this.editdata = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }),
  
      catchError((err) => {
        console.error('Error updating order:', err);
      
        this.messageType = 'error';
        this.messageText =
          err?.error?.message ||
          'Failed to update order. Please try again.';
        this.showMessage = true;
      
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
      
        return EMPTY;
      }),
  
      finalize(() => {
        this.iseditLoading = false;
        this.isLoading = false;
        this.rightisLoading = false;
        this.cd.detectChanges();
      })
    ).subscribe();
  }

  getTotal(items:any) {
    return items.reduce((sum: any, item: { itemQty: any; }) => sum + item.itemQty, 0);
  }

  resetFilter() {
    this.filterValues.filterbystatus = [''];
    this.selectedproducts=[];
    this.selectedstatus = [];
    this.filterValues.filterbyproduct = [];
    this.count=0;
    this.cd.detectChanges();
    this.applyFilter();
  }

  resetSort() {
    this.sort.sort({
      id: 'column-name',
      start: 'asc',
      disableClear: false
    });
  }

  onKeyPressPO(event:KeyboardEvent) {
    this.poError = false;
    this.cd.detectChanges(); 
  }

  /* ================= HELPERS ================= */

  private isBlockedByCutoff(date: Date): boolean {
    if (this.deliveryConfig.cutoffHour === null) return false;

    const tomorrow = new Date(this.today);
    tomorrow.setDate(this.today.getDate() + 1);

    if (this.getEasternHour() >= this.deliveryConfig.cutoffHour) {
      return date.getTime() === tomorrow.getTime();
    }

    return false;
  }

  private calculateMinRescheduleDate(): Date {
    const base = new Date(this.today);
    base.setDate(base.getDate() + 1);

    if (
      this.deliveryConfig.cutoffHour !== null &&
      this.getEasternHour() >= this.deliveryConfig.cutoffHour
    ) {
      base.setDate(base.getDate() + 1);
    }

    return this.getNextValidDate(base);
  }

  private formatLocalDate(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  private isDayAfterApiHoliday(date: Date): boolean {
    const prevDay = new Date(date);
    prevDay.setDate(prevDay.getDate() - 1);

    const prevIso = this.formatLocalDate(prevDay);
    return this.apiDisabledSet.has(prevIso);
  }

  private prepareApiDisabledDates(): void {
    this.apiDisabledSet.clear();
    this.deliveryConfig.apiDisabledDates.forEach(d =>
      this.apiDisabledSet.add(d)
    );
  }

  private normalizeToday(): void {
    this.today.setHours(0, 0, 0, 0);
  }

  getRemainingRescheduleCount(): number {
    const maxCount = Number(
      this.rightsectionresponse?.shippingCalendar?.maxrRescheduleCount ?? 0
    );
  
    const usedCount = Number(
      this.rightsectionresponse?.currentRescheduleCount ?? 0
    );
  
    return Math.max(maxCount - usedCount, 0);
  }

  private prepareDateWindow(): void {
    this.minSelectableDate = new Date(this.today);

    this.maxSelectableDate = new Date(this.today);

    if (this.deliveryConfig.maxWindowDays !== null) {
      this.maxSelectableDate.setDate(
        this.today.getDate() + this.deliveryConfig.maxWindowDays
      );
    }
  }

  private updateMonthLabel(): void {
    if (!this.calendar || !this.calendar.activeDate) return;

    this.monthLabel = this.calendar.activeDate.toLocaleString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }

  /* ================= CORE BUSINESS LOGIC ================= */

  dateFilter = (date: Date | null): boolean => {
    if (!date) return false;

    const d = new Date(date);
    d.setHours(0, 0, 0, 0);

    if (d.getTime() === this.today.getTime()) {
      return false;
    }

    if (this.isCalendarOpen && this.minRescheduleDate && d < this.minRescheduleDate) {
      return false;
    }

    if (d < this.minSelectableDate || d > this.maxSelectableDate) {
      return false;
    }

    if (this.isBlockedByCutoff(d)) {
      return false;
    }

    if (this.deliveryConfig.disabledWeekdays.includes(d.getDay())) {
      return false;
    }

    const localIso = this.formatLocalDate(d);

    if (this.apiDisabledSet.has(localIso)) {
      return false;
    }

    if (this.isDayAfterApiHoliday(d)) {
      return false;
    }

    return true;
  };

  private isAfterCutoff(date: Date): boolean {
    if (this.deliveryConfig.cutoffHour === null) return false;

    return (
      date.getTime() === this.today.getTime() &&
      this.getEasternHour() >= this.deliveryConfig.cutoffHour
    );
  }

  private getNextValidDate(start: Date): Date {
    const d = new Date(start);
    let attempts = 0;

    while (!this.dateFilter(d)) {
      d.setDate(d.getDate() + 1);
      attempts++;

      if (attempts > 31) {
        throw new Error('No valid delivery date available');
      }
    }

    return d;
  }

  /* ================= UI EVENTS ================= */

  openCalendar(index: number, event: MouseEvent): void {
    event.stopPropagation(); 
    this.minRescheduleDate = this.calculateMinRescheduleDate();

    this.openCalendarIndex = index;
    this.monthLabel = this.confirmedDates[index].toLocaleString('en-US', {
      month: 'long',
      year: 'numeric'
    });

    if (!this.confirmedDates[index]) {
      this.confirmedDates[index] = new Date(this.confirmedDate); 
    }

    this.tempSelectedDates[index] = new Date(this.confirmedDates[index]);
    this.removeCalendarNavTooltips();
  }

  private removeCalendarNavTooltips(): void {
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      const navButtons = document.querySelectorAll<HTMLElement>(
        '.calendar-wrapper button.mat-calendar-previous-button, .calendar-wrapper button.mat-calendar-next-button'
      );

      navButtons.forEach(btn => {
        btn.addEventListener('mouseenter', (e) => {
          e.stopImmediatePropagation();
        }, true);

        btn.addEventListener('focus', (e) => {
          e.stopImmediatePropagation();
        }, true);
      });
    });
  }

  confirmDate(index: number,location?: any): void {
    const selected = this.tempSelectedDates[index];

    if (!selected) return;

    this.confirmedDates[index] = new Date(selected);

    if (location) {
      location.deliveryDate = new Date(selected);
    }

    this.openCalendarIndex = null;
  }

  private getFirstEnabledDates(count: number): Date[] {
    const enabled: Date[] = [];
    const d = new Date(this.minSelectableDate ?? this.today);
    d.setHours(0, 0, 0, 0);

    for (let attempts = 0; enabled.length < count && attempts <= 31; attempts++) {
      if (this.dateFilter(d)) {
        enabled.push(new Date(d));
      }
      d.setDate(d.getDate() + 1);
    }

    return enabled;
  }

  private getIsONSNOrder(): string | null {
    const selectedDate = this.confirmedDates[0];
    if (!selectedDate) return null;

    const firstTwoIso = this.getFirstEnabledDates(2).map(date => this.formatLocalDate(date));
    const isONSNOrder = firstTwoIso.includes(this.formatLocalDate(selectedDate)) ? 'YES' : 'NO';

    return isONSNOrder;
  }

  onDateSelected(index: number, date: Date | null): void {
    if (!date) return;
    this.tempSelectedDates[index] = new Date(date);
  }

  @HostListener('document:click')
  handleOutsideClick(): void {
    this.openCalendarIndex = null;
  }

  onViewChanged(event: { activeDate: Date }): void {
    const date = event.activeDate;

    this.monthLabel = date.toLocaleString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }

  items = Array.from({ length: 1 });

  private applyOrderDateWindow(): void {
    if (!this.rightsectionresponse?.orderDate) return;

    const orderDate = new Date(this.rightsectionresponse.orderDate);

    if (isNaN(orderDate.getTime())) return;

    orderDate.setHours(0, 0, 0, 0);

    this.minSelectableDate =
      orderDate > this.today ? new Date(orderDate) : new Date(this.today);

    if (this.deliveryConfig.maxWindowDays !== null) {
      this.maxSelectableDate = new Date(orderDate);
      this.maxSelectableDate.setDate(
        orderDate.getDate() + this.deliveryConfig.maxWindowDays
      );
    }
  }

  private initializeDeliveryDate(): void {
    if (this.rightsectionresponse?.expectedDeliveryDate) {
      const apiDate = new Date(this.rightsectionresponse.expectedDeliveryDate + 'T00:00:00');
      this.confirmedDates[0] = apiDate;
      this.tempSelectedDates[0] = apiDate;
    }
  }

  private getUpdatedRescheduleCount(): number {
    const current = Number(this.rightsectionresponse?.currentRescheduleCount ?? 0);

    const originalDate = new Date(
      this.rightsectionresponse.expectedDeliveryDate + 'T00:00:00' 
    );

    const hasChanged = this.confirmedDates[0].getTime() !== originalDate.getTime();

    return hasChanged ? current + 1 : current;
  }

  shouldShowDeliveryDetails(): boolean {
    if (!this.rightsectionresponse) return false;

    const expectedDate = new Date(
      this.rightsectionresponse.expectedDeliveryDate + 'T00:00:00' 
    );

    const orderDate = new Date(this.rightsectionresponse.orderDate);

    expectedDate.setHours(0, 0, 0, 0);
    orderDate.setHours(0, 0, 0, 0);

    const isSameDate = expectedDate.getTime() === orderDate.getTime();
    const onsnEnabled = this.rightsectionresponse.ONSNEnabled === true;
    const onsnOrder = this.rightsectionresponse.ONSNOrder === true;

    return !isSameDate && onsnEnabled && onsnOrder;
  }

  closeCalendar() {
    this.openCalendarIndex = null;
  }

  /**
   * UPDATED:
   * safer Eastern hour calculation.
   */
  
  private getEasternHour(): number {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    const hour = Number(parts.find(part => part.type === 'hour')?.value);

    return hour === 24 ? 0 : hour;
  }

  /**
   * NEW:
   * Updates edit button disabled state based on expected delivery date and cutoff.
   */
  private updateEditCutoffState(): void {

    if (!this.shouldShowDeliveryDetails()) {
      this.isEditDisabledByShippingCutoff = false;
      this.showShippingCutoffMessage = false;
      this.editdata = false;
      return;
    }
  
    this.isEditDisabledByShippingCutoff =
      this.isEditPermanentlyDisabledByCutoff();

    this.showShippingCutoffMessage =
      this.shouldDisableEditAfterShippingCutoff();
  
    if (this.isEditDisabledByShippingCutoff) {
      this.editdata = false;
    }
}

  /**
   * NEW:
   * Returns true only when:
   * 1. expectedDeliveryDate is tomorrow as per Eastern timezone
   * 2. current Eastern hour is greater than or equal to cutoffHour
   */
  private shouldDisableEditAfterShippingCutoff(): boolean {

    // If delivery details are not applicable,
    // edit button should never be disabled
    if (!this.shouldShowDeliveryDetails()) {
      return false;
    }
  
    if (!this.rightsectionresponse?.expectedDeliveryDate) {
      return false;
    }
  
    const cutoffHour = this.deliveryConfig.cutoffHour ?? 13;
  
    const expectedDeliveryDate = this.parseApiDateOnly(
      this.rightsectionresponse.expectedDeliveryDate
    );
  
    if (!expectedDeliveryDate) {
      return false;
    }
  
    const easternToday = this.getEasternTodayDateOnly();
  
    const easternTomorrow = new Date(easternToday);
    easternTomorrow.setDate(easternToday.getDate() + 1);
  
    const isExpectedDeliveryToday =
      expectedDeliveryDate.getTime() === easternToday.getTime();
  
    const isExpectedDeliveryTomorrow =
      expectedDeliveryDate.getTime() === easternTomorrow.getTime();
  
    const isAfterCutoff =
      this.getEasternHour() >= cutoffHour;
  
    // NEW FINAL RULE:
    // 1. If delivery date is today => disable edit immediately
    // 2. If delivery date is tomorrow and after cutoff => disable edit
    return (
      isExpectedDeliveryToday ||
      (isExpectedDeliveryTomorrow && isAfterCutoff)
    );
  }

  /**
   * NEW:
   * Parses API date as local date-only value.
   * This avoids timezone shifting issues from yyyy-MM-dd strings.
   */
  private parseApiDateOnly(value: any): Date | null {
    if (!value) {
      return null;
    }

    const dateString = String(value).split('T')[0];
    const dateParts = dateString.split('-').map(Number);

    if (dateParts.length === 3 && dateParts.every(part => !isNaN(part))) {
      const parsedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      parsedDate.setHours(0, 0, 0, 0);
      return parsedDate;
    }

    const fallbackDate = new Date(value);

    if (isNaN(fallbackDate.getTime())) {
      return null;
    }

    fallbackDate.setHours(0, 0, 0, 0);
    return fallbackDate;
  }

  /**
   * NEW:
   * Gives today's date as per America/New_York timezone.
   */
  private getEasternTodayDateOnly(): Date {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const year = Number(parts.find(part => part.type === 'year')?.value);
    const month = Number(parts.find(part => part.type === 'month')?.value);
    const day = Number(parts.find(part => part.type === 'day')?.value);

    const easternToday = new Date(year, month - 1, day);
    easternToday.setHours(0, 0, 0, 0);

    return easternToday;
  }
  /**
 * Same as shouldDisableEditAfterShippingCutoff but permanent —
 * once the cutoff point passes, edit stays disabled forever.
 */
private isEditPermanentlyDisabledByCutoff(): boolean {
    if (!this.shouldShowDeliveryDetails()) {
      return false;
    }

    if (!this.rightsectionresponse?.expectedDeliveryDate) {
      return false;
    }

    const cutoffHour = this.deliveryConfig.cutoffHour ?? 13;

    const expectedDeliveryDate = this.parseApiDateOnly(
      this.rightsectionresponse.expectedDeliveryDate
    );

    if (!expectedDeliveryDate) {
      return false;
    }

    const oneDayBefore = new Date(expectedDeliveryDate);
    oneDayBefore.setDate(expectedDeliveryDate.getDate() - 1);

    const easternToday = this.getEasternTodayDateOnly();
    const easternHour = this.getEasternHour();

    return (
      easternToday.getTime() > oneDayBefore.getTime() ||
      (easternToday.getTime() === oneDayBefore.getTime() && easternHour >= cutoffHour)
    );
}

  updatePrepaymentEditState(): void {

    const prePaymentOrder =
      String(this.rightsectionresponse?.isPrePaymentOrder ?? '').toLowerCase() || 'no';

    const prepaymentCustomer =
      String(this.userInfoService.getPrePaymentCustomer() ?? '').toLowerCase() || 'no';
      
    this.isEditDisabledByPrepayment =
      prePaymentOrder === 'yes' ||
      (prePaymentOrder === 'no' && prepaymentCustomer === 'yes');
  }

  isEditDisabled(): boolean {
    return (
      this.isEditDisabledByShippingCutoff ||
      this.isEditDisabledByPrepayment
    );
  }
}